import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  public showLoadingIndicator$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  public updateShowLoadingIndicator(indicator: boolean): void {
    this.showLoadingIndicator$.next(indicator);
  }
}
